import { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../Config';
import { useIonScreenAuth } from '../Authentication/Hooks/useIonScreenAuth';
import { UserDto } from '../DTO/UserDto';
import { Link, useNavigate } from 'react-router-dom';
import LoadingComponent from './LoadingComponent';

const Page_Users = () => {
    const [users, setUsers] = useState<UserDto[]>([]);
    const context = useIonScreenAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const abortController = new AbortController();
        getUsersAsync(abortController);
        return () => {
            abortController.abort();
        };
    }, []);

    const getUsersAsync = async (abortController: AbortController) => {
        try {
            let axiosRequestConfig = await context.getAxiosRequestObjectAsync(abortController);
            var result = await axios.get<UserDto[]>(config.backEndAppApi + `/api/GetUsers`, axiosRequestConfig);
            setUsers(result.data);
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setLoading(false);
        }
    }

    const HandleAddClicked = () => {
        navigate(`/user`);
    }

    const HandleDeleteClicked = async (userId: number) => {
        if (!window.confirm('Are you sure you want to delete this user?')) {
            return;
        }

        try {
            let axiosRequestConfig = await context.getAxiosRequestObjectAsync(null);
            await axios.delete(config.backEndAppApi + `/api/DeleteUser/${userId}`, axiosRequestConfig);
            setUsers(users.filter(u => u.id !== userId));
        }
        catch (error) {
            console.log(error);
            alert('Failed to delete user');
        }
    }

    if (loading) {
        return (<LoadingComponent />);
    }

    return (
        <>
            <h1 className='underline text-xl'>Users</h1>
            <table className='table-auto border-collapse border border-gray-400'>
                <thead>
                    <tr className='bg-gray-100'>
                        <th className='border border-gray-400 px-4 py-2'>Id</th>
                        <th className='border border-gray-400 px-4 py-2'>Email</th>
                        <th className='border border-gray-400 px-4 py-2'>First Name</th>
                        <th className='border border-gray-400 px-4 py-2'>Last Name</th>
                        <th className='border border-gray-400 px-4 py-2'>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(u => (<tr key={`${u.id}`}>
                        <td className='border border-gray-400 px-4 py-2'><Link className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600" to={`/user/${u.id}`}>{u.id}</Link></td>
                        <td className='border border-gray-400 px-4 py-2'>{u.email}</td>
                        <td className='border border-gray-400 px-4 py-2'>{u.firstName}</td>
                        <td className='border border-gray-400 px-4 py-2'>{u.lastName}</td>
                        <td className='border border-gray-400 px-4 py-2'>
                            <Link to={`/user/${u.id}`} className="underline text-blue-600 hover:text-blue-800 mr-4">Edit</Link>
                            <button
                                className="text-red-600 hover:text-red-800 cursor-pointer"
                                onClick={() => HandleDeleteClicked(u.id)}
                            >
                                Delete
                            </button>
                        </td>
                    </tr>))}
                </tbody>
            </table>
            <br />
            <br />
            <button className="bg-blue-300 text-white font-bold py-2 px-4 rounded hover:bg-blue-400" onClick={HandleAddClicked}>Add User</button>
        </>
    );
}

export default Page_Users;
